import type { ScatterDataPoint } from 'chart.js';
import { getGroupLimit } from '../../../../../../../utils/chargePoints/diagnostics';
import { ThreePhase } from '../../../../../../../utils/meterValues';
import { LLMServerModel } from './LLMServerModel';

export class LLMGroupLimitModel extends LLMServerModel {
  getDatum(args: { phase: ThreePhase }): ScatterDataPoint {
    const { phase } = args;
    return {
      x: new Date(this.serverEventDate).getTime(),
      y: getGroupLimit({ groupLimit: this.server.GroupLimit, phase }),
    };
  }
}
